import React from 'react';

import styles from './notOnline.module.css';

const NotOnline = ({ isOffline, noDoctors, error, clearState }) => (
  <div className={styles.container}>
    {noDoctors && (
      <div>
        It appears doctors/clinics are unable to provide services at this time.
        <br />
        Please check your details and contact the practice.
        <br />
        <br />
        <button className={styles.loginLink} onClick={clearState}>
          Retry
        </button>
      </div>
    )}
    {isOffline && (
      <div style={{ color: '#ff0000' }}>
        Vensa online booking service is temporarily unavailable.
        <br />
        Please check back later to book your appointment.
        <br />
        We're working on getting things back up and running!
      </div>
    )}
    {error &&
      (error?.response?.body?.Reason ? (
        <div>
          {error.response.body.Reason.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
          <br />
          <button className={styles.loginLink} onClick={clearState}>
            Retry
          </button>
        </div>
      ) : (
        <div>
          It appears doctors/clinics are unable to provide services at this
          time.
          <br />
          Please check your details and contact the practice.
          <br />
          <br />
          <button className={styles.loginLink} onClick={clearState}>
            Retry
          </button>
        </div>
      ))}
  </div>
);

export default NotOnline;
